import Dropzone from "react-dropzone"

export default function CustomDropzone({ value, onChange, onRemove, edit, accept }) {
  const handleAcceptedFiles = async files => {
    if (files.length == 0) return
    onChange && onChange(files[0])
  }

  const handleFileRejections = fileRejections => {
    let tooManyFiles = false
    for (let i = 0; i < fileRejections.length; i++) {
      for (let e = 0; e < fileRejections[i].errors.length; e++) {
        if (fileRejections[i].errors[e].code === "too-many-files") {
          tooManyFiles = true
          break
        }
      }
    }

    if (tooManyFiles) {
      window.alert("Você só pode enviar um arquivo.")
    } else {
      window.alert("Houve algum erro ao arrastar o arquivo, por favor clicar e selecionar o arquivo manualmente.")
    }
  }

  const handleRemove = (ev) => {
    onRemove && onRemove()
  }

  return (
    <Dropzone
      onDrop={acceptedFiles => handleAcceptedFiles(acceptedFiles)}
      onDropRejected={fileRejections => handleFileRejections(fileRejections)}
      disabled={!edit}
      accept={accept}
    >
      {({ getRootProps, getInputProps }) => (
        <div className="position-relative">
          <div className="dropbox" {...getRootProps()}>
            <div>
              <div className="text-center">
                <input {...getInputProps()} />

                {value ? (
                  <>
                    <h4>{value.path}</h4>
                    <p style={{ fontSize: 14, fontWeight: "normal", color: edit ? 'normal' : '#ccc' }}>
                      Se desejar excluir esse arquivo, arraste o novo arquivo ou clique para selecionar outro.
                    </p>
                  </>
                ) : (
                  <h4 style={{ color: edit ? 'normal' : '#ccc' }}>Arraste um arquivo aqui ou clique para selecionar.</h4>
                )}
              </div>

            </div>
          </div>
          {(value && edit) && (
            <i className="bi bi-trash custom-button position-absolute top-0 right-0 mr-2 mt-2" onClick={handleRemove}></i>
          )}
        </div>
      )}
    </Dropzone>
  )
}